export const getStates = () => {
    return [
        { option: "AC", value: "Acre" },
        { option: "AL", value: "Alagoas" },
        { option: "AP", value: "Amapá" },
        { option: "AM", value: "Amazonas" },
        { option: "BA", value: "Bahia" },
        { option: "CE", value: "Ceará" },
        { option: "DF", value: "Distrito Federal" },
        { option: "ES", value: "Espírito Santo" },
        { option: "GO", value: "Goiás" },
        { option: "MA", value: "Maranhão" },
        { option: "MT", value: "Mato Grosso" },
        { option: "MS", value: "Mato Grosso do Sul" },
        { option: "MG", value: "Minas Gerais" },
        { option: "PA", value: "Pará" },
        { option: "PB", value: "Paraíba" },
        { option: "PR", value: "Paraná" },
        { option: "PE", value: "Pernambuco" },
        { option: "PI", value: "Piauí" },
        { option: "RJ", value: "Rio de Janeiro" },
        { option: "RN", value: "Rio Grande do Norte" },
        { option: "RS", value: "Rio Grande do Sul" },
        { option: "RO", value: "Rondônia" },
        { option: "RR", value: "Roraima" },
        { option: "SC", value: "Santa Catarina" },
        { option: "SP", value: "São Paulo" },
        { option: "SE", value: "Sergipe" },
        { option: "TO", value: "Tocantins" },
    ]
}
